import { Week } from "../../components/week/week";

/**
 * @function Reservation displays the reservation page
 * @returns {JSX.Element} HTML content
 */
function Reservation() {
  return (
    <div className="flex flex-col bg-white rootHome min-h-screen">
      <Week />
    </div>
  );
}

export { Reservation };